/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { classNames, tagName } from '@ember-decorators/component';
import { action, computed } from '@ember/object';
import { equal } from '@ember/object/computed';
import Component from '@ember/component';
import { next } from '@ember/runloop';
import { sortByCaseInsensitive } from 'cio/utils/sort';

@tagName('div')
@classNames('wysihtml5-toolbar', 'px-3', 'py-1.5')
export default class Wysihtml5Toolbar extends Component {
  attribute = null;
  formatBlock = null;
  isTextArea = false;
  sentAttributes = null;
  showAssetLibraryModal = false;

  @equal('isTextArea', true) disabled;

  formatBlocks = [
    {
      label: 'Heading 1',
      value: 'h1',
      className: 'h1',
    },
    {
      label: 'Heading 2',
      value: 'h2',
      className: 'h2',
    },
    {
      label: 'Normal text',
      value: 'div',
      className: 'font-normal',
    },
  ];

  @computed('sentAttributes')
  get attributes() {
    return sortByCaseInsensitive(
      this.get('sentAttributes').map((attribute, index) => ({
        value: index,
        label: attribute,
      })),
      ['label'],
    );
  }

  @action
  pickFileFromAssetLibrary(imagePath) {
    window.wysihtml5EditorInstance.currentView.element.focus();
    window.wysihtml5EditorInstance.composer.commands.exec('insertImage', imagePath);
    this.set('showAssetLibraryModal', false);
  }

  @action
  onFormatBlock(item) {
    this.set('formatBlock', item.value);

    window.wysihtml5EditorInstance.composer.commands.exec('formatBlock', item.value);
    this.focusEditor();
  }

  @action
  onInsertAttribute(attribute) {
    this.set('attribute', attribute.value);

    let attributeMarkup;

    // Use bracket notation if attribute name contains whitespace
    if (/\s/.test(attribute.label)) {
      attributeMarkup = `customer["${attribute.label}"]`;
    } else {
      attributeMarkup = `customer.${attribute.label}`;
    }

    window.wysihtml5EditorInstance.composer.commands.exec('insertLiquid', attributeMarkup);
    this.focusEditor();
  }

  focusEditor() {
    next(() => window.wysihtml5EditorInstance.focus());
  }
}
